import { navBarList } from "../models/models";


export const tabList: navBarList[] = [
    {
        tabName: 'Home',
        tabLink: "/#home"
    },
    // {  // TODO: Add feature section later.
    //     tabName: 'Featured',
    //     tabLink: "/#featured"
    // },
    {
        tabName: 'Projects',
        tabLink: "/#projects"
    },
    {
        tabName: 'Skills',
        tabLink: "/#skills"
    },
    {
        tabName: 'Work',
        tabLink: "/#work"
    },
    {
        tabName: 'Education',
        tabLink: "/#education"
    },

]
